export function NMTipoGuiaRemision(codigo){
    switch (codigo) {
        case '09':
            return 'Remitente';
            break;
        case '31':
            return 'Transportista';
            break;
        default:
            // console.log(codigo);
            return 'Código no identificado';
            break;
    }
}

export function NMMotivoTraslado(codigo){
    // console.log("ejecución motivo");
    switch (codigo) {
        case '01':
            return 'Venta';
            break;
        case '02':
            return 'Compra';
            break;
        case '04':
            return 'Traslado entre establecimientos de la misma empresa';
            break;
        case '13':
            return 'Otros';
            break;
        default:
            // console.log(codigo);
            return 'Codigo no identificado';
            break;
    }
}

export function NMModalidadTraslado(codigo){
    // console.log("ejecución motivo");
    switch (codigo) {
        case '01':
            return 'Transporte público';
            break;
        case '02':
            return 'Transporte privado';
            break;
        default:
            // console.log(codigo);
            return 'Codigo no identificado';
            break;
    }
}

export function NMTipoDocumento(codigo, abreviado){
    // console.log("ejecución nombre");
    if(abreviado == true){
        switch (codigo) {
            case '1':
                return 'DNI';
                break;
            case '6':
                return 'RUC';
                break;
            default:
                // console.log(codigo);
                return 'Codigo no identificado';
                break;
        }
    }else{
        switch (codigo) {
            case '1':
                return 'Documento Nacional de Identidad';
                break;
            case '6':
                return 'Registro Único de Contribuyentes';
                break;
            default:
                // console.log(codigo);
                return 'Codigo no identificado';
                break;
        }
    }
}

export function NMTipoComprobante(codigo){
    switch (codigo) {
        case '01':
            return 'Factura';
            break;
        case '03':
            return 'Boleta';
            break;
        case '07':
            return 'Nota de crédito';
            break;
        case '08':
            return 'Nota de débito';
            break;
        default:
            // console.log(codigo);
            return 'Codigo no identificado';
            break;
    }
}

export function MostrarFecha(fecha){
    const fechaSinHora = fecha.split("T")[0];
    const partesFecha = fechaSinHora.split("-");
    const anio = partesFecha[0];
    const mes = partesFecha[1];
    const dia = partesFecha[2];
    return `${dia}/${mes}/${anio}`;
}

export function NMMotivoTrasladoLista(codigo){
    switch (codigo) {
        case '01':
            return 'Venta';
            break;
        case '02':
            return 'Compra';
            break;
        case '04':
            return 'Traslado';
            break;
        case '13':
            return 'Otros';
            break;
        default:            
            return 'Codigo no identificado' + codigo;
            break;
    }
}

export function NMTipoDireccion(tipo){
    switch (tipo) {
        case "anexo":
            return "Establecimiento Anexo";
            break;
        case "frecuente":
            return "Dirección Frecuente";
            break;
        default:
            return "Tipo Desconocido"
            break;
    }
}

export function NMEntidadEmisora(codigo){
    let nombreEntidad = '';
    switch (codigo) {
        case '01':
            nombreEntidad = 'SUCAMEC';
            break;
        case '02':
            nombreEntidad = 'DIGEMID';
            break;
        case '03':
            nombreEntidad = 'DIGESA';
            break;
        case '04':
            nombreEntidad = 'SENASA';
            break;
        case '05':
            nombreEntidad = 'SERFOR';
            break;
        case '06':
            nombreEntidad = 'MTC';
            break;
        case '07':
            nombreEntidad = 'PRODUCE';
            break;
        case '08':
            nombreEntidad = 'MIN. AMBIENTE';
            break;
        case '09':
            nombreEntidad = 'SANIPES';
            break;
        case '10':
            nombreEntidad = 'MML';
            break;
        case '11':
            nombreEntidad = 'MINSA';
            break;
        case '12':
            nombreEntidad = 'GR';
            break;
    }
    return nombreEntidad;
}